import { SearchTitleComponent } from "./components/searchTitle.component";
import { Base } from "./title.base";

export const Title = Object.assign(Base, {
    Component: SearchTitleComponent
});
